module.exports = __webpack_public_path__ + "static/img/lbx.0dea0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbx.png
// module id = cSiF
// module chunks = 1